import { MenuItem } from "@mui/material";
import { useFormikContext } from "formik";
import moment from 'moment';
import FormikDatePicker from "./formikDatePicker";
import FormikSelect from "./formikSelect";

const periodOptions = [
  {
    value: "all",
    label: "Cualquier día",
    getDateRange: (today) => ({ startDate: null, endDate: null })
  },
  {
    value: "today",
    label: "Hoy",
    getDateRange: (today) => ({ startDate: moment(today).toDate(), endDate: moment(today).toDate() })
  },
  {
    value: "48h",
    label: "Últimas 48 horas",
    getDateRange: (today) => ({ startDate: moment(today).subtract(48, "hours").toDate(), endDate: moment(today).toDate() })
  },
  {
    value: "7d",
    label: "Últimos 7 días",
    getDateRange: (today) => ({ startDate: moment(today).subtract(7, "days").toDate(), endDate: moment(today).toDate() })
  },
  {
    value: "1m",
    label: "Último mes",
    getDateRange: (today) => ({ startDate: moment(today).subtract(1, "months").toDate(), endDate: moment(today).toDate() })
  },
  {
    value: "3m",
    label: "Últimos 3 meses",
    getDateRange: (today) => ({ startDate: moment(today).subtract(3, "months").toDate(), endDate: moment(today).toDate() })
  },
  {
    value: "custom",
    label: "Personalizado"
  },
];


export const FormikDateRangeSearch = ({ name = "datePeriod", label = "Período", startDateFieldName = "startDate", endDateFieldName = "endDate", ...props }) => {
  const { setFieldValue } = useFormikContext();
  return (
    <>
      <FormikSelect
        name={name}
        label={label}
        variant="standard"
        callBack={(value) => {
          const today = new Date();
          const option = periodOptions.find(opt => opt.value === value);
          if (option?.getDateRange) {
            const { startDate, endDate } = option.getDateRange(today);
            setFieldValue(endDateFieldName, endDate)
              .then(() => {
                setFieldValue(startDateFieldName, startDate);
              });
          }
        }}
        {...props}
      >
        {periodOptions.map((option) => (
          <MenuItem value={option.value} key={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </FormikSelect>
    </>
  )
}

export const FormikDateRangeInput = ({ name, label, rangePickerName = "datePeriod", ...props }) => {
  const { setFieldValue } = useFormikContext();
  return (
    <FormikDatePicker
      name={name}
      label={label}
      callBack={(value) => {
        setFieldValue(rangePickerName, "custom");
      }}
      {...props}
    />
  )
}